/*eslint-disable*/
import React, {
    useCallback,
    useEffect,
    useRef,
    useState,
    useMemo,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { FormattedMessage, IntlProvider } from "react-intl";
import { useNetwork } from "../../components/NetworkProvider";
import DailyView from "../../components/KilometerTracker/DailyView";
import { Tooltip } from "@mui/material";
import CalendarViewToggle from "../../components/Buttons/CalendarViewToggle";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import Fab from "@mui/material/Fab";

import TimeEntry from "../../components/KilometerTracker/TimeEntry";

import { Button, IconButton } from "@mui/material";

import {
    FiChevronLeft,
    FiChevronRight,
    FiPlus,
    FiRefreshCcw,
    FiBell,
} from "react-icons/fi";

import {
    HiCalendar,
    HiCalendarDays,
    HiOutlineBars3,
    HiOutlineCalendarDays,
    HiPlus,
} from "react-icons/hi2";

import FastAPIClient from "../../client";
import fast_api_config from "../../config";

import CalendarModule from "../../components/Calendar";
// import ToggleButton from "../../components/Buttons/ToggleButton";
import Loader from "../../components/Loader";
import DraggableMeetingList from "../../components/LayoutComponents/DraggableMeetingList";
import RoutingMap from "../../components/MapComponents/RoutingMap";
import MeetingModal from "../../components/ModalComponents/MeetingModal";
import { useOfflineMeetings } from "../../components/OfflineContext";

import {
    formatNewMeeting,
    blankMeetingData,
    formatExistingMeeting,
    formatRoutingEvent,
    formatMeetingToToday,
} from "../../utils/Meetings/functions";

import messages_en from "./translations/en.json";
import messages_pt from "./translations/pt.json";
import messages_fr from "./translations/fr.json";

import update from "immutability-helper";

import "./style.css";
import Reminders from "../../components/Reminders";

// Instantiate the FastAPI client
const client = new FastAPIClient(fast_api_config);

// Messages for localization
const messages = {
    en: messages_en,
    pt: messages_pt,
    fr: messages_fr,
};

const Routing = () => {
    const { isOnline } = useNetwork();
    const [viewMode, setViewMode] = useState("daily"); // new state for switching views
    const location = useLocation(); // Hook to get the current URL
    const navigate = useNavigate(); // Hook to update the URL
    const { offlineMeetings, offlineDeleteMeeting, offlineUpdateMeeting } =
        useOfflineMeetings(); // Destructure the offlineMeetings state from the context
    const queryParams = new URLSearchParams(location.search);
    const [usersData, setUsersData] = useState([]);
    const [meetings, setMeetings] = useState([]);
    const [detailsTrue, setDetailsTrue] = useState(false);
    const [calendarLoading, setCalendarLoading] = useState(false);
    const [original_meetings, setOriginalMeetings] = useState([]);
    const [selectedDraggable, setSelectedDraggable] = useState("");
    const [currentDate, setCurrentDate] = useState(new Date());
    const [filteredMeetings, setFilteredMeetings] = useState([]); // State for filtered meetings
    const [activeCalendars, setActiveCalendars] = useState([]);
    const now = new Date();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [selectedMeeting, setSelectedMeeting] = useState(null);

    // Function to format date for display
    const formatDate = (date) => {
        return date
            .toLocaleDateString("fr-FR", {
                year: "numeric",
                month: "long",
                day: "numeric",
            })
            .replace(/\b\p{Ll}/u, (char) => char.toUpperCase()); // Capitalize first letter of the first lowercase word
    };

    const user = JSON.parse(localStorage.getItem("user"));

    // Get users data
    const fetchUsersData = async () => {
        const data = await client.getUsers();
        setUsersData(data.results);
    };

    // Handle changing date by one day
    const handleNextDay = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate); // Create a new Date object
            newDate.setDate(newDate.getDate() + 1); // Increment the date by one day
            setNewEventData({ ...newEventData, start: newDate }); // Update newEventData with the new date
            return newDate; // Return the new date
        });
    };

    // Handle changing date by one day
    const handlePreviousDay = () => {
        setCurrentDate((prevDate) => {
            const newDate = new Date(prevDate); // Create a new Date object
            newDate.setDate(newDate.getDate() - 1); // Increment the date by one day
            setNewEventData({ ...newEventData, start: newDate }); // Update newEventData with the new date
            return newDate; // Return the new date
        });
    };

    const [meetingTypes, setMeetingTypes] = useState([]);

    // Extract onTransformedMeetings method: Transform meetings data
    const onTransformedMeetings = (data) => {
        if (!data?.length) return [];
        return data.map((meeting) => formatRoutingEvent(meeting));
    };

    // total_original_meetings: original_meetings concat with offline meetings
    const total_original_meetings = useMemo(() => {
        let meetingsList = original_meetings;
        if (offlineMeetings.length) {
            // Only add offline meetings that don't exist in original_meetings
            const originalIds = new Set(
                original_meetings.map((m) => m.meeting_id)
            );
            const newOfflineMeetings = offlineMeetings.filter(
                (meeting) => !originalIds.has(meeting.meeting_id)
            );
            meetingsList = meetingsList.concat(newOfflineMeetings);
        }
        if (offlineDeleteMeeting.length) {
            meetingsList = meetingsList.filter(
                (meeting) => !offlineDeleteMeeting.includes(meeting.meeting_id)
            );
        }
        if (offlineUpdateMeeting.length) {
            meetingsList = meetingsList.map((meeting) => {
                const updateMeeting = offlineUpdateMeeting.find(
                    (updateMeeting) =>
                        updateMeeting.meeting_id === meeting.meeting_id
                );
                if (updateMeeting) {
                    return {
                        ...meeting,
                        ...updateMeeting,
                        is_organizer: true,
                    };
                }
                return meeting;
            });
        }
        return meetingsList.sort(
            (a, b) => new Date(a.start_date) - new Date(b.start_date)
        ); // Sort by start date
    }, [
        offlineMeetings,
        offlineDeleteMeeting,
        offlineUpdateMeeting,
        original_meetings,
    ]);

    const getMeetings = async () => {
        setCalendarLoading(true);
        try {
            const user = JSON.parse(localStorage.getItem("user"));
            const data = await client.getMeetings(user.user_id);
            setOriginalMeetings(data.data?.results);
            const transformedMeetings = onTransformedMeetings(
                data.data?.results
            );
            setMeetings(transformedMeetings);
            filterMeetingsByDate(new Date()); // Filter meetings for today's date initially
        } catch (error) {
            console.error("Error fetching meetings:", error);
        }
        setRefreshing(false);
        setCalendarLoading(false);
    };
    useEffect(() => {
        setMeetings(onTransformedMeetings(original_meetings));
    }, [original_meetings]);

    const filterMeetingsByDate = (date) => {
        const selectedDateString = date.toISOString().split("T")[0]; // Get YYYY-MM-DD format
        // const filtered = meetings.filter((meeting) => {
        //     // Extract the date portion from meeting.date
        //     const meetingDateString = meeting.date.split("T")[0]; // Get YYYY-MM-DD format from meeting.date

        //     // Compare only the date parts
        //     return meetingDateString === selectedDateString;
        // });

        let totalMeetings = [
            ...meetings,
            ...onTransformedMeetings(offlineMeetings),
        ];
        if (offlineDeleteMeeting.length) {
            totalMeetings = totalMeetings.filter(
                (meeting) => !offlineDeleteMeeting.includes(meeting.meeting_id)
            );
        }
        if (offlineUpdateMeeting.length) {
            const formatOfflineUpdateMeeting =
                onTransformedMeetings(offlineUpdateMeeting);
            totalMeetings = totalMeetings.map((meeting) => {
                const updatedMeeting = formatOfflineUpdateMeeting.find(
                    (updatedMeeting) =>
                        updatedMeeting.meeting_id === meeting.meeting_id
                );
                if (updatedMeeting) {
                    return { ...meeting, ...updatedMeeting };
                }
                return meeting;
            });
        }
        const filtered = totalMeetings.filter((meeting) => {
            // Extract the date portion from meeting.date
            const meetingDateString = meeting?.date?.split("T")[0]; // Get YYYY-MM-DD format from meeting.date
            // Compare only the date parts
            return meetingDateString === selectedDateString;
        });

        // Sort by the date field
        const sortedResults = filtered.sort((a, b) => {
            return new Date(a.date) - new Date(b.date);
        });

        setFilteredMeetings(sortedResults);
        // setFilteredMeetings(filtered);
        // if (filtered.length > 0) {
        //     setRefreshing(false); // Immediately stop refreshing if condition is met
        // }
    };

    useEffect(() => {
        filterMeetingsByDate(currentDate); // Call the filter whenever selectedDate changes
    }, [
        currentDate,
        original_meetings,
        meetings,
        detailsTrue,
        offlineMeetings,
        offlineDeleteMeeting,
        offlineUpdateMeeting,
    ]);

    // TEMP FIX but won't work on offline mode, need to find a way to update meetings differently
    useEffect(() => {
        // After the offline data is cleared, refresh the meeting UI on the departure page
        getMeetings();
        fetchMeetingTypes();
        fetchUsersData();
    }, []);

    const handleViewToggle = () => {
        const newViewMode = viewMode === "daily" ? "weekly" : "daily";
        setViewMode(newViewMode);
        navigate(`?view=${newViewMode}`); // Update URL with the new view mode
    };

    useEffect(() => {
        if (viewMode === "daily") {
            if (activeCalendars.length > 1) {
                setActiveCalendars([user.user_id]);
                setOriginalMeetings((prev) =>
                    prev.filter((meeting) => meeting.user_id === user.user_id)
                );
            }
        }
    }, [viewMode]);

    const [refreshing, setRefreshing] = useState(true);
    const [locale, setLocale] = useState(
        () => localStorage.getItem("language") || "en"
    );

    useEffect(() => {
        // Read viewMode from URL when component mounts
        const currentView = queryParams.get("view");
        if (currentView && currentView !== viewMode) {
            setViewMode(currentView);
        }
    }, [location]);

    const moveCard = useCallback((dragIndex, hoverIndex) => {
        setFilteredMeetings((prevCards) =>
            update(prevCards, {
                $splice: [
                    [dragIndex, 1],
                    [hoverIndex, 0, prevCards[dragIndex]],
                ],
            })
        );
    }, []);

    const fetchMeetingTypes = () => {
        client.getMeetingTypes().then((data) => {
            setMeetingTypes(data?.data.results || []);
        });
    };

    const [newEventData, setNewEventData] = useState(blankMeetingData);

    const [reminders, setReminder] = useState([]);
    const [allReminders, setAllReminders] = useState([]);

    // Function to update the reminder list
    const handleSetReminder = (updatedReminders) => {
        if (updatedReminders) {
            setReminder(updatedReminders);
        }
    };

    useEffect(() => {
        const handleOnlineStatus = () => {
            if (navigator.onLine) {
                fetchReminder(currentDate);
            } else {
            }
        };

        // Run once on mount
        handleOnlineStatus();

        // Listen for network status changes
        window.addEventListener("online", handleOnlineStatus);
        window.addEventListener("offline", handleOnlineStatus);

        return () => {
            window.removeEventListener("online", handleOnlineStatus);
            window.removeEventListener("offline", handleOnlineStatus);
        };
    }, [currentDate]);

    useEffect(() => {
        sortReminders(allReminders);
    }, [currentDate]);

    const sortReminders = (sortedResults) => {
        const formatDate = new Date(currentDate).toISOString().split("T")[0]; // e.g., "2025-01-25"

        // // Get current date in YYYY-MM-DD format for comparison
        // const currentDate = new Date().toISOString().split("T")[0]; // e.g., "2025-01-25"

        // Filter reminders where the date is today's date
        const filteredReminders = sortedResults.filter((reminder) => {
            // Convert reminder.date to a Date object
            const reminderDate = new Date(reminder.date);

            // Create a new Date object for currentDate (to ensure it's just the date part, no time)
            const currentDateWithoutTime = new Date(currentDate);

            // Set both dates' time to midnight to ignore time differences
            reminderDate.setHours(0, 0, 0, 0);
            currentDateWithoutTime.setHours(0, 0, 0, 0);

            // Compare the two date objects (ignoring time)
            return reminderDate.getTime() === currentDateWithoutTime.getTime();
        });

        setReminder(filteredReminders);
    };
    const fetchReminder = () => {
        if (user.user_id != null) {
            client.getReminder(null, user.user_id).then((data) => {
                const sortedResults = data.results;
                setAllReminders(sortedResults);
                sortReminders(sortedResults);
            });
        } else {
            console.log("user_id is null or undefined, skipping API call.");
        }
    };

    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => setSuccessMessage(""), 3000); // Hide message after 3 seconds
            return () => clearTimeout(timer); // Cleanup on unmount
        }
    }, [currentDate]);

    useEffect(() => {
        if (selectedMeeting) {
            setNewEventData(formatExistingMeeting(selectedMeeting));
            openModal();
        }
    }, [selectedMeeting]);

    const openModal = () => {
        if (!selectedMeeting) {
            formatMeetingToToday(
                currentDate,
                setNewEventData,
                user,
                setDetailsTrue
            );
        }

        setIsModalOpen(true);
    };

    const closeModal = () => {
        setSelectedMeeting(null);
        setIsModalOpen(false);
    };

    const addNewEvent = (newMeeting) => {
        if (isOnline) {
            setOriginalMeetings((prevMeetings) => [
                ...prevMeetings,
                {
                    title: newMeeting.title,
                    description: newMeeting.description,
                    client_name: newMeeting.client_name,
                    meeting_id: newMeeting.meeting_id,
                    start_date: newMeeting.start_date,
                    end_date: newMeeting.end_date,
                    user: newMeeting.user,
                    user_id: newMeeting.user.user_id,
                    meeting_type_id: newMeeting.meeting_type_id,
                    attendees: newMeeting.attendees,
                    is_visited: false,
                    is_recurring: newMeeting.is_recurring,
                    recurring_id: newMeeting.recurring_id,
                    is_organizer: true,
                    lat: newMeeting.lat,
                    long: newMeeting.long,
                    address_1: newMeeting.address_1,
                    zip_code: newMeeting.zip_code,
                    city: newMeeting.city,
                    country: newMeeting.country,
                    client: newMeeting.client,
                },
            ]);
        }
    };

    const [meetingUpdated, setMeetingUpdated] = useState({});

    useEffect(() => {
        updateAllMeetings(meetingUpdated);
    }, [meetingUpdated]);

    // update existing event : drag and drop
    const updateExistingEvent = (updatedMeeting) => {
        setMeetingUpdated(updatedMeeting);
    };
    const updateAllMeetings = (meetingToUpdate) => {
        if (isOnline) {
            setOriginalMeetings((prevMeetings) =>
                prevMeetings.map(
                    (meeting) =>
                        meeting.meeting_id === meetingToUpdate.meeting_id
                            ? {
                                  ...meeting,
                                  title: meetingToUpdate.title,
                                  user: meetingToUpdate.user,
                                  description: meetingToUpdate.description,
                                  lat: meetingToUpdate.lat,
                                  long: meetingToUpdate.long,
                                  address_1: meetingToUpdate.address_1,
                                  zip_code: meetingToUpdate.zip_code,
                                  city: meetingToUpdate.city,
                                  country: meetingToUpdate.country,
                                  user_id: meetingToUpdate.user_id,
                                  client: meetingToUpdate.client,
                                  start_date: meetingToUpdate.start_date,
                                  end_date: meetingToUpdate.end_date,
                                  attendees: meetingToUpdate.attendees,
                                  meeting_type_id:
                                      meetingToUpdate.meeting_type_id,
                                  is_organizer: true,
                              }
                            : meeting // Return unchanged meeting
                )
            );
        }
    };

    const handleDeleteEvent = async (eventId) => {
        setIsUpdating(true);
        try {
            await client.deleteMeeting(eventId);
            setOriginalMeetings((prevMeetings) =>
                prevMeetings.filter((meeting) => meeting.meeting_id !== eventId)
            );
            setMeetings((prevMeetings) =>
                prevMeetings.filter((meeting) => meeting.meeting_id !== eventId)
            );
            setSuccessMessage("delete.success");
            setIsUpdating(false);
        } catch (error) {
            console.error("Failed to delete meeting:", error);
            setIsUpdating(false);
        }
    };

    const [successMessage, setSuccessMessage] = useState(""); // Track success message
    useEffect(() => {
        if (successMessage) {
            const timer = setTimeout(() => setSuccessMessage(""), 3000); // Hide message after 3 seconds
            return () => clearTimeout(timer); // Cleanup on unmount
        }
    }, [successMessage]);

    const [errorMessage, setErrorMessage] = useState(""); // Track success message
    useEffect(() => {
        if (errorMessage) {
            const timer = setTimeout(() => setErrorMessage(""), 3000); // Hide message after 3 seconds
            return () => clearTimeout(timer); // Cleanup on unmount
        }
    }, [errorMessage]);

    const clientText = (card) => {
        if (card.client_id && card.client.client_name !== card.title) {
            return card.client.client_name;
        } else {
            return meetingTypes?.find(
                (mt) => mt.meeting_type_id === card.meeting_type_id
            )?.description;
        }
    };

    if (refreshing) {
        return <Loader />; // Display Loader while data is being fetched
    }

    return (
        <DndProvider backend={HTML5Backend}>
            <IntlProvider locale={locale} messages={messages[locale]}>
                <section className="w-full h-full flex flex-row overflow-y-hidden">
                    {viewMode === "daily" ? (
                        <div className="flex md:flex-row md:items-center mt-10 md:mt-0 md:h-full w-full md:w-2/5 xl:w-1/3">
                            <div className="flex flex-col items-center w-full h-full relative">
                                <div className="md:flex md:justify-between md:items-center md:mt-10 md:mb-10 hidden bg-white w-full px-4">
                                    <CalendarViewToggle
                                        viewMode={viewMode}
                                        onChange={handleViewToggle}
                                    />

                                    {/* "Nouveau Réunion" button on the right */}
                                    <Button
                                        onClick={openModal}
                                        variant="contained"
                                        color="primary"
                                        startIcon={<HiCalendarDays />}
                                    >
                                        <FormattedMessage id="button.newMeeting" />
                                    </Button>
                                </div>

                                <div className="flex flex-row md:mb-10 items-center justify-center w-full bg-white text-black">
                                    <Tooltip
                                        title={
                                            <FormattedMessage id="tooltip.previous" />
                                        }
                                        arrow
                                    >
                                        <IconButton
                                            aria-label="delete"
                                            onClick={handlePreviousDay}
                                        >
                                            <FiChevronLeft />
                                        </IconButton>
                                    </Tooltip>
                                    <div className="w-1/2 text-lg font-semibold">
                                        <div className="text-black">
                                            {currentDate
                                                .toLocaleDateString("fr-FR", {
                                                    weekday: "long",
                                                })
                                                .charAt(0)
                                                .toUpperCase() +
                                                currentDate
                                                    .toLocaleDateString(
                                                        "fr-FR",
                                                        { weekday: "long" }
                                                    )
                                                    .slice(1)}
                                        </div>
                                        <div className="text-sm text-black">
                                            {formatDate(currentDate)}{" "}
                                        </div>
                                    </div>
                                    <Tooltip
                                        title={
                                            <FormattedMessage id="tooltip.next" />
                                        }
                                        arrow
                                    >
                                        <IconButton
                                            aria-label="delete"
                                            onClick={handleNextDay}
                                        >
                                            <FiChevronRight />
                                        </IconButton>
                                    </Tooltip>
                                </div>

                                <div className="overflow-y-auto overflow-x-hidden h-[90%] md:h-full custom-scrollbar w-full pb-40 md:pb-20">
                                    <Reminders
                                        reminders={reminders}
                                        setReminder={handleSetReminder}
                                    />

                                    {filteredMeetings.length === 0 ? (
                                        <div className="text-center py-10">
                                            <h2 className="base font-semibold text-black mb-2 p-10">
                                                Pas encore de rendez-vous
                                                programmé pour ce jour.
                                            </h2>
                                        </div>
                                    ) : (
                                        meetingTypes.length > 0 &&
                                        filteredMeetings.map((card, i) => (
                                            <DraggableMeetingList
                                                key={card.meeting_id}
                                                index={i}
                                                id={card.client_id}
                                                client={card.client}
                                                text={clientText(card)}
                                                time={card.time}
                                                meeting_id={card.meeting_id}
                                                meeting_type={
                                                    card.meeting_type_id
                                                }
                                                moveCard={moveCard}
                                                isLastCard={
                                                    i ===
                                                    filteredMeetings.length - 1
                                                }
                                                locale={locale}
                                                selectedDraggable={
                                                    selectedDraggable
                                                }
                                                setSelectedDraggable={
                                                    setSelectedDraggable
                                                }
                                                isModalOpen={isModalOpen}
                                                setIsModalOpen={setIsModalOpen}
                                                meetingData={card}
                                                setSelectedMeeting={
                                                    setSelectedMeeting
                                                }
                                                openModal={openModal}
                                                setDetailsTrue={setDetailsTrue}
                                                is_visited={card.is_visited}
                                                is_lead={card.is_lead}
                                                alert={card.alert}
                                                title={card.title}
                                                is_recurring={card.is_recurring}
                                            />
                                        ))
                                    )}
                                </div>
                                <div
                                    className={`absolute md:hidden bottom-20 mb-32  right-5 ${
                                        location.search.includes(
                                            "settings=true"
                                        ) ||
                                        location.search.includes(
                                            "notifications=true"
                                        )
                                            ? "hidden"
                                            : ""
                                    }`}
                                    style={{ zIndex: 50 }}
                                >
                                    <Fab
                                        color="primary"
                                        aria-label="add"
                                        onClick={openModal}
                                        size="medium"
                                        style={{ zIndex: 50 }}
                                    >
                                        <HiCalendarDays className="text-lg" />
                                    </Fab>
                                </div>

                                {isModalOpen && user.user_id && (
                                    <MeetingModal
                                        closeModal={closeModal}
                                        initialEventData={newEventData}
                                        locale={locale}
                                        detailsTrue={detailsTrue}
                                        setDetailsTrue={setDetailsTrue}
                                        user_id={user.user_id}
                                        user={user}
                                        setSuccessMessage={setSuccessMessage}
                                        setErrorMessage={setErrorMessage}
                                        attendees={usersData}
                                        onCreateMeeting={addNewEvent}
                                        onUpdateMeeting={updateExistingEvent}
                                        onDeleteMeeting={handleDeleteEvent}
                                    />
                                )}
                                {new Date(currentDate).setHours(0, 0, 0, 0) <=
                                    new Date().setHours(0, 0, 0, 0) &&
                                    user.is_kilometer_module &&
                                    user.user_id &&
                                    navigator.onLine && ( // Check if the user is online
                                        <DailyView
                                            date={currentDate}
                                            user_id={user.user_id}
                                        />
                                    )}
                            </div>
                        </div>
                    ) : (
                        // Weekly View: Only show the calendar
                        <div className="ml-4 w-full h-full">
                            {total_original_meetings &&
                                meetingTypes.length > 0 && (
                                    <CalendarModule
                                        usersData={usersData}
                                        meetings={total_original_meetings}
                                        locale={locale}
                                        detailsTrue={detailsTrue}
                                        setDetailsTrue={setDetailsTrue}
                                        setOriginalMeetings={
                                            setOriginalMeetings
                                        }
                                        meetingTypes={meetingTypes}
                                        activeCalendars={activeCalendars}
                                        setActiveCalendars={setActiveCalendars}
                                        calendarLoading={calendarLoading}
                                        setCalendarLoading={setCalendarLoading}
                                        addNewEvent={addNewEvent}
                                        meetingUpdated={meetingUpdated}
                                        setMeetingUpdated={setMeetingUpdated}
                                        handleDeleteEvent={handleDeleteEvent}
                                        successMessage={successMessage}
                                        errorMessage={errorMessage}
                                        setSuccessMessage={setSuccessMessage}
                                        setErrorMessage={setErrorMessage}
                                    />
                                )}
                            <div className="flex flex-row justify-end h-1/6 items-center">
                                <ul className="flex space-x-2 text-xs gap-2 p-2 text-left items-center">
                                    {meetingTypes &&
                                        meetingTypes.map((meeting) => (
                                            <li
                                                key={meeting.meeting_type_id}
                                                className="grid grid-cols-[20px_1fr] items-center"
                                            >
                                                <div
                                                    className={`w-2 h-2 rounded-full`}
                                                    style={{
                                                        backgroundColor:
                                                            meeting.color,
                                                    }} // Apply hex color here
                                                />
                                                <div>{meeting.description}</div>
                                            </li>
                                        ))}
                                </ul>
                            </div>
                        </div>
                    )}

                    {viewMode === "daily" && (
                        <RoutingMap
                            cards={filteredMeetings}
                            selectedPoint={selectedDraggable}
                        />
                    )}
                    {successMessage && (
                        <div className="fixed top-1 md:top-auto md:bottom-0 left-0 right-0 bg-green-500 text-white text-center py-2 z-50 mx-auto w-5/6 md:w-1/5  rounded-b-lg rounded-t-lg md:rounded-b-none">
                            <FormattedMessage id={successMessage} />
                        </div>
                    )}
                    {errorMessage && (
                        <div className="fixed bottom-0 left-0 right-0 bg-rose-500 text-white text-center py-2 z-50 mx-auto w-1/5 rounded-t-lg">
                            {errorMessage}
                        </div>
                    )}
                </section>
            </IntlProvider>
        </DndProvider>
    );
};

export default Routing;
